export default function processPromoCode(
  text: string | null | undefined,
): string | null {
  if (text == null) {
    return null;
  }

  return text.replace(/\W+/g, '').toUpperCase();
}
